import { siteData, realImages } from "../mock";
import { SITE_URL } from "./pageMeta";

export const BUSINESS_ID = `${SITE_URL}/#business`;
export const PERSON_ID = `${SITE_URL}/#person`;
const RESALIB_URL = "https://www.resalib.fr/praticien/120570-jean-christophe-happillon-fasciatherapeute-quint-fonsegrives";
const PHONE = "+33782476336";

export const businessSchema = {
  "@context": "https://schema.org",
  "@type": "HealthAndBeautyBusiness",
  "@id": BUSINESS_ID,
  name: siteData.brand.name,
  url: SITE_URL,
  telephone: PHONE,
  image: realImages.hero,
  address: {
    "@type": "PostalAddress",
    streetAddress: "5 bis rue du Négoce",
    addressLocality: "Saint-Orens-de-Gameville",
    postalCode: "31650",
    addressRegion: "Occitanie",
    addressCountry: "FR",
  },
  areaServed: siteData.zones.map((z) => ({ "@type": "City", name: z })),
  founder: { "@id": PERSON_ID },
  sameAs: [siteData.google.profileUrl, RESALIB_URL],
};

export const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": PERSON_ID,
  name: "Jean-Christophe Happillon",
  jobTitle: siteData.practitioner.title,
  image: realImages.portrait,
  telephone: PHONE,
  worksFor: { "@id": BUSINESS_ID },
  knowsAbout: ["Fasciathérapie", "Tissual Balancing", "Sport santé", "Coaching sportif à domicile", "Activité physique adaptée"],
  hasCredential: siteData.about.certifications.map((c) => ({ "@type": "EducationalOccupationalCredential", name: c })),
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${encodeURI(it.path)}`,
  })),
});

export const serviceSchema = ({ name, serviceType, description, areaServed }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  serviceType,
  description,
  provider: { "@id": BUSINESS_ID },
  areaServed: areaServed.map((n) => ({ "@type": "City", name: n })),
});
